import { destroyToken } from "../utils/apiService/accountApiService";
import { SPLASH } from "./Routes";

export default async function removeToken(isAccountDeleted) {
  if (!isAccountDeleted) {
    await destroyToken();
  }
  window.location.href = SPLASH;
  localStorage.clear();
}
